import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=154d231e&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154d231e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154d231e')) {
      api.createRecord('154d231e', component.options)
    } else {
      api.reload('154d231e', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=154d231e&scoped=true&", function () {
      api.rerender('154d231e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/comp/Voucher-Unit.vue"
export default component.exports